package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.grid_customer_card_bar.component


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.styleModifier
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card.LoyaltyCardItem
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.components.InfiniteScrollGrid
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun CustomerCardGridItemList(
    items: List<LoyaltyCardItem?>,
    onItemClick: (String) -> Unit,
    id: String,
    loadMoreData: () -> Unit,
) {
    val selectedItemId = remember { mutableStateOf<String?>(null) }

    LaunchedEffect(id) {
        selectedItemId.value = id
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(0.px)
            .styleModifier {
                flexGrow(1)
                overflow(Overflow.Auto)
                display(DisplayStyle.Flex)
                position(Position.Relative)
            }
    ) {

        InfiniteScrollGrid(
            items = items,
            onLoadMore = {
                loadMoreData()
            }
        ) { index ->
            val model = items[index]
            CustomerCardGridItem(
                model = model,
                isSelected = selectedItemId.value == model?.id,
                onItemClick = { id ->
                    onItemClick(id)
                },
            )
        }

    }
}

